import { instance } from '@/api/instances'

const fetchSpecialties = async store => {
  try {
    if (store.state.specialties?.length) {
      return store.state.specialties
    }
    const specialties = await instance.get('specialties')
    store.commit('setSpecialties', specialties)
    return specialties
  } catch (error) {
    store.dispatch(
      'errors/setError',
      { error, request: 'specialist/fetchSpecialties' },
      { root: true }
    )
    return []
  }
}

const fetchAttendantByName = async (store, { query, signal }) => {
  try {
    const params = { q: query }
    return await instance.get('filters/attendant', { params, signal })
  } catch (error) {
    store.dispatch(
      'errors/setError',
      { error, request: 'specialist/fetchAttendantByName' },
      { root: true }
    )
    return []
  }
}

const fetchSubspecialtiesBySpecialtyId = async (store, specialtyId) => {
  try {
    const subSpecialties = await instance.get(
      `specialties/${specialtyId}/sub_specialties`
    )

    store.commit('setSubspecialties', { specialtyId, subSpecialties })
    return subSpecialties
  } catch (error) {
    store.dispatch(
      'errors/setError',
      { error, request: 'specialist/fetchSubspecialtiesBySpecialtyId' },
      { root: true }
    )
    return []
  }
}

const fetchSpecialistsBySpecialty = async (store, { specialtyId }) => {
  try {
    const specialists = await instance.get(
      `specialties/${specialtyId}/specialists`
    )

    return specialists
  } catch (error) {
    store.dispatch(
      'errors/setError',
      { error, request: 'specialist/fetchSpecialistsBySpecialty' },
      { root: true }
    )
    return []
  }
}

const fetchSpecialists = async (
  store,
  { personId, specialtyId, subSpecialtyId }
) => {
  const person_id = personId ?? store.rootState.pillars.personId
  try {
    const specialists = await instance.get('specialists', {
      params: {
        person_id,
        specialty_id: specialtyId,
        sub_specialty_id: subSpecialtyId || null
      }
    })

    return specialists
  } catch (error) {
    store.dispatch(
      'errors/setError',
      { error, request: 'specialist/fetchSpecialists' },
      { root: true }
    )
    return []
  }
}

const checkSpecialistMemberTier = async (
  store,
  { personId, specialistId, specialistType }
) => {
  try {
    const person_id = personId ?? store.rootState.pillars.personId
    const specialistTier = await instance.get(
      `persons/${person_id}/specialists/is_in_member_tier`,
      {
        params: {
          specialist_id: specialistId,
          specialist_type: specialistType
        }
      }
    )

    return specialistTier
  } catch (error) {
    store.dispatch(
      'errors/setError',
      { error, request: 'specialist/checkSpecialistMemberTier' },
      { root: true }
    )
    return false
  }
}

const getSpecialistGlobalData = async store => {
  try {
    const response = await instance.get('specialist')
    const json = await response
    store.commit('setSpecialistData', json)
  } catch {
    return false
  }
}

export default {
  fetchSpecialistsBySpecialty,
  fetchSpecialties,
  fetchSubspecialtiesBySpecialtyId,
  fetchSpecialists,
  checkSpecialistMemberTier,
  fetchAttendantByName,
  getSpecialistGlobalData
}
